import React, { FC, useState } from "react";
import { useMutation } from "@apollo/client/react";
import { faSpinner, faTimesCircle, faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouter } from "next/navigation";

import Button from "@/components/button";
import { ButtonBar, Module } from "@/components/layouts";
import { ButtonGroup } from "@/components/layouts/button-group";
import { MUTATE_DELETE_ANIMATION } from "@/gql/queries/mutate-delete-animation";
import { useModal } from "@/hooks/use-modal";

import ModalTitle from "./modal-title";

type ConfirmAnimationDeleteModalProps = {
  id: number;
};

const ConfirmAnimationDeleteModal = ({
  id,
}: ConfirmAnimationDeleteModalProps) => {
  const { closeModal } = useModal();
  const [isDeleting, setIsDeleting] = useState(false);
  const { push } = useRouter();
  const [deleteAnimation] = useMutation(MUTATE_DELETE_ANIMATION, {
    onCompleted: () => {
      closeModal();
      push("/my-studio");
    },
  });

  const onDeleteClicked = () => {
    setIsDeleting(true);
    deleteAnimation({ variables: { id } });
  };

  if (isDeleting) {
    return (
      <div className="text-center">
        <ModalTitle>Delete Animation</ModalTitle>
        <Module>
          <p>Deleting animation...</p>
        </Module>
        <div className="text-5xl text-gray-500">
          <FontAwesomeIcon icon={faSpinner} spin />
        </div>
      </div>
    );
  }

  return (
    <div>
      <ModalTitle>Delete Animation</ModalTitle>
      <Module>
        <p>Are you sure you want to delete this animation?</p>
        <p>
          This action is <strong>permanent</strong> and{" "}
          <strong>the animation cannot be retrieved</strong>.
        </p>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faTrashAlt}
            onClick={onDeleteClicked}
            type="negative"
          >
            Permanently delete
          </Button>
          <Button
            icon={faTimesCircle}
            onClick={closeModal}
            type="positive"
          >
            Cancel and keep
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
};

export default ConfirmAnimationDeleteModal;
